import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

const ReclassificationOperationTableHeader: FC = () => {
  const { t } = useTranslate();

  return (
    <thead>
      <tr className="nk-tb-item tb-tnx-head">
        <th className="nk-tb-col text-left">{t('Partner')}</th>

        <th className="nk-tb-col text-center">{t('From')}</th>

        <th className="nk-tb-col text-center">{t('To')}</th>

        <th className="nk-tb-col text-left">{t('Class')}</th>

        <th className="nk-tb-col text-center">{t('NewFrom')}</th>

        <th className="nk-tb-col text-center">{t('NewTo')}</th>

        <th className="nk-tb-col text-left">{t('NewClass')}</th>
      </tr>
    </thead>
  );
};

export default ReclassificationOperationTableHeader;
